import * as types from '../Actions/types';

const INIT_STATE = {
    referenceData: []
};

const Job = (state = INIT_STATE, action) => {
    switch(action.type){
        case types.INIT_LOGOUT:
            return INIT_STATE;

        case types.JOB_REFERENCE_DATA:
            return {
                ...state,
                referenceData: action.data
            }

        case types.ADD_JOB_REFERENCE:
            return {
                ...state,
                referenceData: [...state.referenceData, action.data]
            }

        case types.REMOVE_JOB_REFERENCE:
            return {
                ...state,
                referenceData: state.referenceData.filter((data, index) => index !== action.id)
            }

        default:
            return state;
    }
};

export default Job;